<template>
  <a-row class="content-fix" type="flex">
    <!-- Spinner for loading -->
    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1" style="padding-top: 30px">
      <!-- <span slot="tab"><a-icon type="project" />Создать</span> -->

      <!-- Dynamic Form Fields -->
      <a-row
        v-for="field in fields"
        :key="field.key"
        align="middle"
        :class="{ 'form-group--error': errors[field.key] }"
        class="form-group flex-baseline"
      >
        <a-col :span="4" class="form_title">
          <label>{{ $t(field.label) }}</label>
        </a-col>
        <a-col :span="12" class="sm-mb">
          <a-input
            v-if="field.type === 'text'"
            v-model="form[field.key]"
            :placeholder="$t(field.placeholder)"
            @input="validateLength(field.key, field.minLength, field.maxLength)"
          />
          <a-input
            v-else-if="field.type === 'date'"
            v-model="form[field.key]"
            type="date"
            :placeholder="$t(field.placeholder)"
            class="input-date"
          />

          <a-select
            v-else-if="field.type === 'select' && field.key === 'quarter'"
            v-model="form[field.key]"
            style="width: 100%"
            :disabled="form.period_type === 'annual'"
          >
            <a-select-option
              v-for="option in field.options"
              :key="option.value"
              :value="option.value"
            >
              {{ $t(option.label) }}
            </a-select-option>
          </a-select>

          <a-select
            v-else-if="field.type === 'select'"
            v-model="form[field.key]"
            style="width: 100%"
          >
            <a-select-option
              v-for="option in field.options"
              :key="option.value"
              :value="option.value"
            >
              {{ $t(option.label) }}
            </a-select-option>
          </a-select>

          <!-- <a-upload v-else-if="field.type === 'file'" :before-upload="beforeUpload" :file-list="fileList"
                        @remove="handleRemove">
                        <a-button>
                            <a-icon type="upload" /> {{ $t("SelectFile") }}
                        </a-button>
                    </a-upload> -->

          <a-row v-else-if="field.type === 'file'" class="flex-baseline">
            <a-col :span="12">
              <a-button
                type="primary"
                @click="triggerFileInput"
                @remove="handleRemove"
              >
                <a-icon type="upload" />Upload File
              </a-button>
              <input
                ref="documentRef"
                accept=".xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf"
                hidden
                type="file"
                @change="handleDocumentInput"
              />

              <!-- Show Selected File Name -->
              <div v-if="fileName" style="margin-top: 10px">
                <strong>Selected File:</strong> {{ fileName }}
              </div>

              <!-- Show Existing File Link (if applicable) -->
              <!-- <div v-if="form.date_file" style="margin-top: 10px">
                                <a :href="form.date_file" target="_blank" style="color: #1890ff">
                                    <a-icon type="link" />Open Uploaded File
                                </a>
                            </div> -->
              <!-- Remove selected file -->
              <a-button
                v-if="form.date_file"
                style="margin-top: 10px"
                type="danger"
                @click="handleRemove"
              >
                >
                <a-icon type="delete" />Remove file
              </a-button>
            </a-col>
          </a-row>

          <a-switch
            v-else-if="field.type === 'switch'"
            v-model="form[field.key]"
          />
        </a-col>
      </a-row>

      <!-- Action Buttons -->
      <a-row class="form-buttons__action" type="flex">
        <a-col :span="3" class="form_title" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>
          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit()"
          >
            <a-icon type="check" />
            Создать
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  name: "CreateCertificate",
  data() {
    return {
      fileName: "",
      form: {
        title: "",
        year_id: null,
        period_type: "",
        publication_date: "",
        is_published: false,
        data_file: null,
        quarter: null
      }, // Data to store form values
      fields: [
        {
          key: "title",
          label: "TableTitle",
          type: "text",
          placeholder: "TableTitle"
        },
        {
          key: "period_type",
          label: "PeriodType",
          type: "select",
          placeholder: "PeriodType",
          options: [
            { value: "annual", label: "Annual" },
            { value: "quarterly", label: "Quarterly" }
          ]
        },
        {
          key: "publication_date",
          label: "PublicationDate",
          type: "date"
        },
        { key: "is_published", label: "Status", type: "switch" },
        {
          key: "quarter",
          label: "FormQuarter",
          type: "select",
          options: [
            { value: 1, label: "quarter1" },
            { value: 2, label: "quarter2" },
            { value: 3, label: "quarter3" },
            { value: 4, label: "quarter4" }
          ]
        },
        {
          key: "file",
          type: "file",
          label: "File"
        }
      ],
      errors: {}, // Validation errors
      pending: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      years: "mtms/getYears"
    })
  },
  watch: {
    "form.period_type"(val) {
      if (val === "annual") {
        this.form.quarter = null
      }
    }
  },

  created() {},

  methods: {
    ...mapActions({
      createGeneralStat: "mtms/createGeneralStat",
      fetchYears: "mtms/fetchYears"
    }),
    triggerFileInput() {
      const input = Array.isArray(this.$refs.documentRef)
        ? this.$refs.documentRef[0]
        : this.$refs.documentRef

      if (input && typeof input.click === "function") {
        input.click()
      } else {
        console.warn("File input ref not found!")
      }
    },
    handleRemove() {
      this.form.data_file = null
      this.fileName = ""
    },
    handleDocumentInput(event) {
      const file = event.target.files[0]
      if (file) {
        this.form.data_file = file
        this.fileName = file.name
        this.$refs.documentRef.value = "" // Reset file input to allow re-selection
      }
    },
    validateLength(key, minlength, maxlength) {
      const value = this.form[key]
      if (value.length > maxlength) {
        this.form[key] = value.substring(0, maxlength) // Trim to maxlength
      }
      if (value.length < minlength) {
        this.errors[key] = `Minimum length is ${minlength} characters.`
      } else {
        this.errors[key] = null // Clear error if valid
      }
    },
    isDisabled(field) {
      if (field.key === "quarter" && this.form.period_type === "annual") {
        return true
      }
      return false
    },
    async submit() {
      try {
        this.pending = true

        await this.fetchYears()
        const selectedYear = Number(this.$route.params.year)

        for (const item of this.years.data) {
          if (item.year === selectedYear) {
            this.form.year_id = item.id
            break
          }
        }

        const fd = new FormData()
        for (const key in this.form) {
          const value = this.form[key]
          if (value === null || value === undefined) continue

          if (value instanceof File) {
            fd.append(key, value)
          } else if (typeof value === "boolean") {
            fd.append(key, value) // raw boolean
          } else {
            fd.append(key, String(value))
          }
        }

        const response = await this.$api.post(
          "/admin/common/general-statistics/",
          fd,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        )

        const { data } = response

        if (data) {
          this.$message.success("Data successfully imported")

          this.$router.go(-1) // Adjust the route as needed
        } else {
          this.$message.warning("Failed to import data.")
        }
        this.pending = false
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style scoped>
.content-fix {
  /* background: #f5f5f5; */
  padding: 20px;
  border-radius: 8px;
}

.form_title {
  font-weight: bold;
  margin-bottom: 8px;
}

.input-date {
  width: 100%;
  max-width: 300px;
  padding: 5px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group--error .form_title {
  color: red;
}

.form-buttons__action {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
